import CurdTable from "@/components/CurdTable.vue";
import SumTable from "@/components/SumTable.vue";

export default {
	data() {
		return {
			loadings: {
				main: false,
				filter: false,
			},
			sorts: {
				sortKey: "",
				sortOrder: "desc",
			},
			editorVisible: false,
			editorBatchVisible: false,
			editorId: "",
			activeName: "list",
			batchConfirmInfo:{
				count:0,
				sum:0,
				recordIds:[]
			}
		};
	},

	methods: {
		handleCreate() {
			this.editorId = "";
			this.editorVisible = true;
		},
		handleEdit(id) {
			this.editorId = id;
			this.editorVisible = true;
		},
		handleSort(sorts) {
			this.sorts.sortKey = sorts.sortKey;
			this.sorts.sortOrder = sorts.sortOrder;
		},
		refreshTable(table) {
			if (!this.$refs[table]) {
				return;
			}
			this.$nextTick(() => {
				this.$refs[table].refreshData();
			});
		},
		handleClickBatchOp(key, checks) {
			let func = 'handleBatch_'+key;
			if (!this[func]) {
				alert(func+'方法不存在');
				return;
			}
			this[func]( checks);
		},
		doExport(dataModel, url = "", exportView = null, fieldsShow = null) {
			this.loadings.filter = true;
			if (!url) {
				url = `/curd/export/${dataModel}`;
			}
			if (!fieldsShow && this.$refs["listTable"]) {
				fieldsShow = this.$refs["listTable"].fieldsShow;
			}
			this.$axios
				.post(
					url,
					{
						page: this.hasPage ? this.paginations.main.pageNow : -999,
						sortKey: this.sorts.sortKey,
						sortOrder: this.sorts.sortOrder,
						searchFilter: this.searchFilter,
						dateFilter: this.dateFilter,
						kvFilter: this.kvFilter,
						view: exportView,
						fieldsShow: fieldsShow,
					},
					{ responseType: "arraybuffer" },
				)
				.then(res => {
					this.loadings.filter = false;

					let blob = new Blob([res], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
					});
					let objectUrl = URL.createObjectURL(blob);
					window.location.href = objectUrl;
				})
				.catch(res => {
					console.error(res);
					this.loadings.filter = false;

					// 错误信息
				});
		},
	},
	components: {
		CurdTable,
		SumTable,
	},
	watch: {},
};
